import styled from "styled-components";
import { NewButton } from "@bca/ui-library";
import { Link } from "react-router-dom";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  margin-top: 2.875rem;
`;

export const StyledButton = styled(NewButton)`
  width: ${(props) => (props.isMobile ? "8.18rem" : "11.43rem")};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
